/* eslint-disable react-refresh/only-export-components */
import styled from '@emotion/styled';
import { Box, Theme } from '@mui/material';

const Dot = styled(Box)({
  width: 10,
  height: 10,
  borderRadius: '50%',
  display: 'inline-block',
});

const DotOutline = styled(Box)({
  width: 10,
  height: 10,
  borderRadius: '50%',
  borderWidth: 2,
  borderStyle: 'solid',
  display: 'inline-block',
});

export type DotIndicatorProps = {
  color?: keyof Pick<Theme['palette'], 'success' | 'warning' | 'error' | 'grey'>;
  outlined?: boolean;
};

export const DotIndicator = ({ color, outlined = false }: DotIndicatorProps) => {
  if (!color) {
    return null;
  }

  if (outlined) {
    return <DotOutline sx={{ borderColor: color }} />;
  }

  return <Dot sx={{ backgroundColor: color }} />;
};
